import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import {
    GetPermissionInfoStatus,
    RecipientPermissionInfo,
} from '../../schema/RecipientPermissionInfo';
import { SharingData } from '../../schema/SharingData';
import { SharingRecipientsInfo } from '../../schema/SharingRecipientsInfo';
import { SharingTipRecipientInfo } from '../../types/SharingTipRecipientInfo';
import { hasGetRecipientPermissionFailed } from '../../utils/recipients/hasGetRecipientPermissionFailed';
import { hasLargeDLRecipient } from '../../utils/recipients/hasLargeDLRecipient';
import { hasRecipientExpansionFailure } from '../../utils/recipients/hasRecipientExpansionFailure';

export function isPermissionNotSet(
    sharingData: SharingData,
    recipientInfo: SharingTipRecipientInfo[]
): boolean {
    if (shouldUseGenericError(sharingData.sharingRecipientsInfo, recipientInfo)) {
        return (
            sharingData.currentPermissionLevel === AttachmentPermissionLevel.None &&
            sharingData.sharingInfo &&
            sharingData.sharingInfo.getSharingInfoSucceeded
        );
    } else {
        return (
            (sharingData.currentPermissionLevel === AttachmentPermissionLevel.None &&
                hasRecipientThatCanNotAccess(sharingData.sharingRecipientsInfo)) ||
            ((sharingData.currentPermissionLevel === AttachmentPermissionLevel.View ||
                sharingData.currentPermissionLevel === AttachmentPermissionLevel.Edit) &&
                hasRecipientThatCanNotHaveAccess(sharingData.sharingRecipientsInfo))
        );
    }
}

export function shouldUseGenericError(
    sharingRecipientsInfo: SharingRecipientsInfo,
    recipientInfo: SharingTipRecipientInfo[]
): boolean {
    return (
        hasLargeDLRecipient(recipientInfo) ||
        hasRecipientExpansionFailure(recipientInfo) ||
        hasGetRecipientPermissionFailed(sharingRecipientsInfo)
    );
}

function hasRecipientThatCanNotAccess(sharingRecipientsInfo: SharingRecipientsInfo): boolean {
    const allRecipients: RecipientPermissionInfo[] = sharingRecipientsInfo.recipientPermissionInfos;
    return allRecipients.some(
        info =>
            !info.hasAccess && info.getPermissionInfoStatus === GetPermissionInfoStatus.Succeeded
    );
}

function hasRecipientThatCanNotHaveAccess(sharingRecipientsInfo: SharingRecipientsInfo): boolean {
    const allRecipients: RecipientPermissionInfo[] = sharingRecipientsInfo.recipientPermissionInfos;
    return allRecipients.some(
        info =>
            !info.hasAccess &&
            !info.canHaveAccess &&
            info.getPermissionInfoStatus === GetPermissionInfoStatus.Succeeded
    );
}
